var _path, _path2, _g, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundsquares4Pricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1152,
    height: 1344,
    viewBox: "0 0 1152 1344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_612_943)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-768 0H1152V1344H-768V0Z",
    fill: "#0C0C11"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_612_943",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -768,
    y: 0,
    width: 1920,
    height: 1344
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-768 0H1152V1344H-768V0Z",
    fill: "url(#paint0_radial_612_943)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_612_943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.000669149 0H-127.999V128H0.000669149M0.000669149 0V128M0.000669149 0H128M0.000669149 128H128M128 0V128M128 0H256V128H128",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 0H384.001V128H256.001V0Z",
    fill: "#404249",
    fillOpacity: 0.858824,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 0H384V128H512M512 0V128M512 0H639.999M512 128H639.999M639.999 0V128M639.999 0H768M639.999 128H768M768 0V128M768 0H896V128H768",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.999 0H1024V128H895.999V0Z",
    fill: "#404249",
    fillOpacity: 0.439216,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 0H1152V128H1024V0Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000661201 128H-127.999V255.999H0.000661201M0.000661201 128V255.999M0.000661201 128H128M0.000661201 255.999H128M128 128V255.999M128 128H256M128 255.999H256M256 128V255.999M256 128H384.001V255.999H256",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 128H512V255.999H384V128Z",
    fill: "#404249",
    fillOpacity: 0.454902,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.001 128H768.001V255.999H640.001V128Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 128H896V255.999H768V128Z",
    fill: "#404249",
    fillOpacity: 0.388235,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 128H895.999V255.999H1024M1024 128V255.999M1024 128H1152V255.999H1024",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-384.001 256H-512V384H-384.001M-384.001 256V384M-384.001 256H-256.001M-384.001 384H-256.001M-256.001 256V384M-256.001 256H-128.001M-256.001 384H-128.001M-128.001 256V384M-128.001 256H-0.000598895V384H-128.001M-640.001 256H-512.001V384H-640.001V256Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 256H128V384H0V256Z",
    fill: "#404249",
    fillOpacity: 0.968627,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.999 256H255.999V384H127.999V256Z",
    fill: "#404249",
    fillOpacity: 0.866667,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.001 256H256.001V384H384.001M384.001 256V384M384.001 256H512M384.001 384H512M512 256V384M512 256H640V384H512",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.001 256H768.001V384H640.001V256Z",
    fill: "#404249",
    fillOpacity: 0.870588,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896 256H768V384H896M896 256V384M896 256H1024M896 384H1024M1024 256V384M1024 256H1152V384H1024",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-256 384H-384V512H-256M-256 384V512M-256 384H-128.001V512H-256M256 384H384V512H256V384Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 384H512V512H384V384Z",
    fill: "#404249",
    fillOpacity: 0.368627,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.999 384H512V512H639.999M639.999 384V512M639.999 384H768M639.999 512H768M768 384V512M768 384H896M768 512H896M896 384V512M896 384H1024V512H896M-640 512H-768V639.999H-640M-640 512V639.999M-640 512H-512.001V639.999H-640",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000661201 512H-127.999V639.999H0.000661201M0.000661201 512V639.999M0.000661201 512H128M0.000661201 639.999H128M128 512V639.999M128 512H256V639.999H128M512 512H384.001V639.999H512M512 512V639.999M512 512H640M512 639.999H640M640 512V639.999M640 512H768.001M640 639.999H768.001M768.001 512V639.999M768.001 512H896V639.999H768.001",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.999 512H1024V639.999H895.999V512Z",
    fill: "#404249",
    fillOpacity: 0.341176,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 512H1152V639.999H1024V512ZM-768 640H-640V768H-768V640ZM-512 640H-384V768H-512V640Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128.001 640H-256.001V768H-128.001M-128.001 640V768M-128.001 640H-0.000669785V768H-128.001",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 640H128V768H0V640Z",
    fill: "#404249",
    fillOpacity: 0.176471,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.999 640H128V768H255.999V640Z",
    fill: "#404249",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.999 640H128V768H255.999M255.999 640V768M255.999 640H384M255.999 768H384M384 640V768M384 640H512M384 768H512M512 640V768M512 640H639.999M512 768H639.999M639.999 640V768M639.999 640H768M639.999 768H768M768 640V768M768 640H896M768 768H896M896 640V768M896 640H1024V768H896M-640 768H-768V896H-640M-640 768V896M-640 768H-512.001M-640 896H-512.001M-512.001 768V896M-512.001 768H-384M-512.001 896H-384M-384 768V896M-384 768H-256V896H-384",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000671387 768H-127.999V896H0.000671387M0.000671387 768V896M0.000671387 768H128M0.000671387 896H128M128 768V896M128 768H256V896H128",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 768H384.001V896H256.001V768Z",
    fill: "#404249",
    fillOpacity: 0.419608,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 768H512V896H384V768Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.999 768H639.999V896H511.999V768Z",
    fill: "#404249",
    fillOpacity: 0.215686,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.001 768H640.001V896H768.001M768.001 768V896M768.001 768H896V896H768.001",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.999 768H1024V896H895.999V768Z",
    fill: "#404249",
    fillOpacity: 0.337255,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 768H1152V896H1024V768Z",
    fill: "#404249",
    fillOpacity: 0.180392,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-640 896H-768V1024H-640M-640 896V1024M-640 896H-512.001V1024H-640M-384 896H-512V1024H-384M-384 896V1024M-384 896H-256M-384 1024H-256M-256 896V1024M-256 896H-128.001M-256 1024H-128.001M-128.001 896V1024M-128.001 896H-1.71661e-05V1024H-128.001M128 896H255.999V1024H128V896Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 896H384.001V1024H256.001V896Z",
    fill: "#404249",
    fillOpacity: 0.529412,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 896H512V1024H384V896Z",
    fill: "#404249",
    fillOpacity: 0.411765,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.999 896H511.999V1024H639.999M639.999 896V1024M639.999 896H767.999V1024H639.999M895.999 896H1024V1024H895.999V896Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 896H1152V1024H1024V896Z",
    fill: "#404249",
    fillOpacity: 0.396078,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-127.999 1024H0.000671387V1152H-127.999V1024Z",
    fill: "#404249",
    fillOpacity: 0.356863,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1024H128V1152H0V1024Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.999 1024H255.999V1152H127.999V1024Z",
    fill: "#404249",
    fillOpacity: 0.996078,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 1024H384.001V1152H256.001V1024Z",
    fill: "#404249",
    fillOpacity: 0.756863,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 1024H512V1152H384V1024Z",
    fill: "#404249",
    fillOpacity: 0.921569,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.999 1024H512V1152H639.999M639.999 1024V1152M639.999 1024H768V1152H639.999M1024 1024H896V1152H1024M1024 1024V1152M1024 1024H1152V1152H1024M-640 1152H-768V1280H-640M-640 1152V1280M-640 1152H-512.001V1280H-640",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 1152H256V1280H384M384 1152V1280M384 1152H512M384 1280H512M512 1152V1280M512 1152H639.999V1280H512M0 1152H128V1280H0V1152Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.001 1152H768.001V1280H640.001V1152Z",
    fill: "#404249",
    fillOpacity: 0.423529,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 1152H896V1280H768V1152Z",
    fill: "#404249",
    fillOpacity: 0.313726,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.999 1152H1024V1280H895.999V1152Z",
    fill: "#404249",
    fillOpacity: 0.505882,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 1152H1152V1280H1024V1152Z",
    fill: "#404249",
    fillOpacity: 0.443137,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-256 1280H-384V1408H-256M-256 1280V1408M-256 1280H-128.001M-256 1408H-128.001M-128.001 1280V1408M-128.001 1280H-8.58307e-06V1408H-128.001",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.999 1280H255.999V1408H127.999V1280Z",
    fill: "#404249",
    fillOpacity: 0.298039,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.001 1280H768.001V1408H640.001V1280Z",
    fill: "#404249",
    fillOpacity: 0.921569,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896 1280H768V1408H896M896 1280V1408M896 1280H1024M896 1408H1024M1024 1280V1408M1024 1280H1152V1408H1024",
    stroke: "#404249",
    strokeWidth: 0.576
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_612_943",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -463,
    y: -139,
    width: 1921,
    height: 1344
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-462.5 -139H1457.5V1205H-462.5V-139Z",
    fill: "url(#paint1_radial_612_943)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_612_943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.000669149 0H-127.999V128H0.000669149M0.000669149 0V128M0.000669149 0H128M0.000669149 128H128M128 0V128M128 0H256V128H128",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 0H384.001V128H256.001V0Z",
    fill: "#404249",
    fillOpacity: 0.858824,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 0H384V128H512M512 0V128M512 0H639.999M512 128H639.999M639.999 0V128M639.999 0H768M639.999 128H768M768 0V128M768 0H896V128H768",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.999 0H1024V128H895.999V0Z",
    fill: "#404249",
    fillOpacity: 0.439216,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 0H1152V128H1024V0Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000661201 128H-127.999V255.999H0.000661201M0.000661201 128V255.999M0.000661201 128H128M0.000661201 255.999H128M128 128V255.999M128 128H256M128 255.999H256M256 128V255.999M256 128H384.001V255.999H256",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 128H512V255.999H384V128Z",
    fill: "#404249",
    fillOpacity: 0.454902,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.001 128H768.001V255.999H640.001V128Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 128H896V255.999H768V128Z",
    fill: "#404249",
    fillOpacity: 0.388235,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 128H895.999V255.999H1024M1024 128V255.999M1024 128H1152V255.999H1024",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-384.001 256H-512V384H-384.001M-384.001 256V384M-384.001 256H-256.001M-384.001 384H-256.001M-256.001 256V384M-256.001 256H-128.001M-256.001 384H-128.001M-128.001 256V384M-128.001 256H-0.000598895V384H-128.001M-640.001 256H-512.001V384H-640.001V256Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 256H128V384H0V256Z",
    fill: "#404249",
    fillOpacity: 0.968627,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.999 256H255.999V384H127.999V256Z",
    fill: "#404249",
    fillOpacity: 0.866667,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.001 256H256.001V384H384.001M384.001 256V384M384.001 256H512M384.001 384H512M512 256V384M512 256H640V384H512",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.001 256H768.001V384H640.001V256Z",
    fill: "#404249",
    fillOpacity: 0.870588,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896 256H768V384H896M896 256V384M896 256H1024M896 384H1024M1024 256V384M1024 256H1152V384H1024",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-256 384H-384V512H-256M-256 384V512M-256 384H-128.001V512H-256M256 384H384V512H256V384Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 384H512V512H384V384Z",
    fill: "#404249",
    fillOpacity: 0.368627,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.999 384H512V512H639.999M639.999 384V512M639.999 384H768M639.999 512H768M768 384V512M768 384H896M768 512H896M896 384V512M896 384H1024V512H896M-640 512H-768V639.999H-640M-640 512V639.999M-640 512H-512.001V639.999H-640",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000661201 512H-127.999V639.999H0.000661201M0.000661201 512V639.999M0.000661201 512H128M0.000661201 639.999H128M128 512V639.999M128 512H256V639.999H128M512 512H384.001V639.999H512M512 512V639.999M512 512H640M512 639.999H640M640 512V639.999M640 512H768.001M640 639.999H768.001M768.001 512V639.999M768.001 512H896V639.999H768.001",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.999 512H1024V639.999H895.999V512Z",
    fill: "#404249",
    fillOpacity: 0.341176,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 512H1152V639.999H1024V512ZM-768 640H-640V768H-768V640ZM-512 640H-384V768H-512V640Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128.001 640H-256.001V768H-128.001M-128.001 640V768M-128.001 640H-0.000669785V768H-128.001",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 640H128V768H0V640Z",
    fill: "#404249",
    fillOpacity: 0.176471,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.999 640H128V768H255.999V640Z",
    fill: "#404249",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.999 640H128V768H255.999M255.999 640V768M255.999 640H384M255.999 768H384M384 640V768M384 640H512M384 768H512M512 640V768M512 640H639.999M512 768H639.999M639.999 640V768M639.999 640H768M639.999 768H768M768 640V768M768 640H896M768 768H896M896 640V768M896 640H1024V768H896M-640 768H-768V896H-640M-640 768V896M-640 768H-512.001M-640 896H-512.001M-512.001 768V896M-512.001 768H-384M-512.001 896H-384M-384 768V896M-384 768H-256V896H-384",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000671387 768H-127.999V896H0.000671387M0.000671387 768V896M0.000671387 768H128M0.000671387 896H128M128 768V896M128 768H256V896H128",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 768H384.001V896H256.001V768Z",
    fill: "#404249",
    fillOpacity: 0.419608,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 768H512V896H384V768Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.999 768H639.999V896H511.999V768Z",
    fill: "#404249",
    fillOpacity: 0.215686,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.001 768H640.001V896H768.001M768.001 768V896M768.001 768H896V896H768.001",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.999 768H1024V896H895.999V768Z",
    fill: "#404249",
    fillOpacity: 0.337255,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 768H1152V896H1024V768Z",
    fill: "#404249",
    fillOpacity: 0.180392,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-640 896H-768V1024H-640M-640 896V1024M-640 896H-512.001V1024H-640M-384 896H-512V1024H-384M-384 896V1024M-384 896H-256M-384 1024H-256M-256 896V1024M-256 896H-128.001M-256 1024H-128.001M-128.001 896V1024M-128.001 896H-1.71661e-05V1024H-128.001M128 896H255.999V1024H128V896Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 896H384.001V1024H256.001V896Z",
    fill: "#404249",
    fillOpacity: 0.529412,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 896H512V1024H384V896Z",
    fill: "#404249",
    fillOpacity: 0.411765,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.999 896H511.999V1024H639.999M639.999 896V1024M639.999 896H767.999V1024H639.999M895.999 896H1024V1024H895.999V896Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 896H1152V1024H1024V896Z",
    fill: "#404249",
    fillOpacity: 0.396078,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-127.999 1024H0.000671387V1152H-127.999V1024Z",
    fill: "#404249",
    fillOpacity: 0.356863,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1024H128V1152H0V1024Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.999 1024H255.999V1152H127.999V1024Z",
    fill: "#404249",
    fillOpacity: 0.996078,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 1024H384.001V1152H256.001V1024Z",
    fill: "#404249",
    fillOpacity: 0.756863,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 1024H512V1152H384V1024Z",
    fill: "#404249",
    fillOpacity: 0.921569,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.999 1024H512V1152H639.999M639.999 1024V1152M639.999 1024H768V1152H639.999M1024 1024H896V1152H1024M1024 1024V1152M1024 1024H1152V1152H1024M-640 1152H-768V1280H-640M-640 1152V1280M-640 1152H-512.001V1280H-640",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 1152H256V1280H384M384 1152V1280M384 1152H512M384 1280H512M512 1152V1280M512 1152H639.999V1280H512M0 1152H128V1280H0V1152Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.001 1152H768.001V1280H640.001V1152Z",
    fill: "#404249",
    fillOpacity: 0.423529,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 1152H896V1280H768V1152Z",
    fill: "#404249",
    fillOpacity: 0.313726,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.999 1152H1024V1280H895.999V1152Z",
    fill: "#404249",
    fillOpacity: 0.505882,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 1152H1152V1280H1024V1152Z",
    fill: "#404249",
    fillOpacity: 0.443137,
    stroke: "#404249",
    strokeWidth: 0.576
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_612_943",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192 672) scale(750 525)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.946
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_612_943",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(497.5 533) scale(750 525)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.946
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612_943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1152,
    height: 1344,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundsquares4Pricing);
export default __webpack_public_path__ + "static/media/backgroundsquares4-Pricing.0e7b8d2053e6f713706c8e62717fd53e.svg";
export { ForwardRef as ReactComponent };